export const moduleId = 'saleReimbursement';

export const state = {
    lists: {},//orglist
    lists1: {},//orglist
    costIsShow: false,//详情显示隐藏
    costIsShow1: false,
    dialogzt: false,//账套显示隐藏
    flag: false,//是否可编辑
    flag1: false,//是否可编辑
    orgId: '',
    isShow: true,
    isShow1: true,
    id: '',
    isDeapproval: false,
    isDeapproval1: false,
    isRouter: false,
    isRouter1: false,
    routeSource: false,
    routeSource1: false,
    isAdd: true,
    abId: '',
    orderNo: '',//发货/发票单号
    billCode: ''
}
export const mutations = {
    setSaleIsAdd(state, flag) {
        state.isAdd = flag
    },
    // setOrgId(state, id) {
    //     state.orgId = id
    // },
    // setTaskId(state, data) {
    //     state.id = data.id
    //     state.abId = data.abId
    // },
    //反审批
    setSaleIsDeapproval(state, data) {
        state.isDeapproval = data
    },
    setSaleIsDeapproval1(state, data) {
        state.isDeapproval1 = data
    },
    setSaleRouteSource(state, data) {
        state.routeSource = data
    },
    setSaleRouteSource1(state, data) {
        state.routeSource1 = data
    },
    setSaleCostIsShow(state, data) {
        state.costIsShow = data
    },
    setSaleCostIsShow1(state, data) {
        state.costIsShow1 = data
    },
    setSaleDialogzt(state, data) {
        state.dialogzt = data
    },
    setSaleOrgList(state, data) {
        state.lists = data
    },
    setSaleOrgList1(state, data) {
        state.lists1 = data
    },
    setSaleFalg(state, data) {
        state.flag = data
    },
    setSaleFalg1(state, data) {
        state.flag1 = data
    },
    setSaleIsRouter(state, data) {
        state.isRouter = data
    },
    setSaleIsRouter1(state, data) {
        state.isRouter1 = data
    },
    setSaleOrderNo(state, data) {
        state.orderNo = data
    },
    setBillCode(state, code) {
        state.billCode = code
    }
}
export const actions = {}


// WEBPACK FOOTER //
// ./src/store/modules/billing-center/sale-reimbursement/index.js